import { Search, Download, Plus } from "lucide-react";
import { Input } from "@/components/ui/input";
import { API } from "@/lib/api";
import { STATUSES, SIZES, StatusPill, fmtDate, todayISO } from "./crmShared";

const sel = "h-9 bg-black/30 border border-gray-800 rounded-lg px-2 text-sm text-white";

export const ProspectFilters = ({ f, setF, states, onAdd }) => {
  const qs = new URLSearchParams(Object.entries(f).filter(([, v]) => v)).toString();
  return (
    <div className="flex flex-wrap items-center gap-2">
      <div className="relative flex-1 min-w-[200px]">
        <Search className="h-4 w-4 text-gray-500 absolute left-3 top-1/2 -translate-y-1/2" />
        <Input data-testid="crm-search" value={f.q} onChange={(e) => setF({ ...f, q: e.target.value })} placeholder="Search church, pastor, email, city…" className="pl-9 bg-black/30 border-gray-800" />
      </div>
      <select data-testid="crm-filter-status" value={f.status} onChange={(e) => setF({ ...f, status: e.target.value })} className={sel}><option value="">All statuses</option>{STATUSES.map((s) => <option key={s}>{s}</option>)}</select>
      <select data-testid="crm-filter-state" value={f.state} onChange={(e) => setF({ ...f, state: e.target.value })} className={sel}><option value="">All states</option>{states.map((s) => <option key={s}>{s}</option>)}</select>
      <select data-testid="crm-filter-size" value={f.size} onChange={(e) => setF({ ...f, size: e.target.value })} className={sel}><option value="">All sizes</option>{SIZES.map((s) => <option key={s}>{s}</option>)}</select>
      <a data-testid="crm-export" href={`${API}/crm/export.csv${qs ? `?${qs}` : ""}`} className="inline-flex items-center gap-1.5 h-9 px-3 rounded-lg border border-gray-700 text-gray-300 hover:text-white hover:border-gray-600 text-sm transition-colors"><Download className="h-4 w-4" /> Export CSV</a>
      <button data-testid="crm-add" onClick={onAdd} className="inline-flex items-center gap-1.5 h-9 px-4 rounded-lg gold-gradient text-black text-sm font-semibold hover:brightness-110"><Plus className="h-4 w-4" /> Add prospect</button>
    </div>
  );
};

export const ProspectTable = ({ rows, onOpen }) => {
  const today = todayISO();
  if (!rows.length) return <p data-testid="crm-list-empty" className="px-5 py-12 text-sm text-gray-500 text-center">No prospects match these filters.</p>;
  return (
    <div className="overflow-x-auto">
      <table data-testid="crm-table" className="w-full text-sm">
        <thead><tr className="text-left text-[11px] uppercase tracking-wider text-gray-500 border-b border-gray-800">
          {["Church", "Pastor", "Location", "Size", "Platforms", "Status", "Last contact", "Next follow-up"].map((h) => <th key={h} className="px-4 py-3 font-medium whitespace-nowrap">{h}</th>)}
        </tr></thead>
        <tbody className="divide-y divide-gray-800/60">
          {rows.map((p) => (
            <tr key={p.id} data-testid={`crm-row-${p.id}`} onClick={() => onOpen(p)} className="cursor-pointer hover:bg-white/[0.03] transition-colors">
              <td className="px-4 py-3"><p className="font-semibold text-white">{p.church_name}</p><p className="text-xs text-gray-500">{p.denomination || ""}</p></td>
              <td className="px-4 py-3 text-gray-300">{p.pastor_name || "—"}<p className="text-xs text-gray-500">{p.phone}</p></td>
              <td className="px-4 py-3 text-gray-300 whitespace-nowrap">{[p.city, p.state].filter(Boolean).join(", ") || "—"}</td>
              <td className="px-4 py-3 text-gray-300">{p.congregation_size || "—"}</td>
              <td className="px-4 py-3 text-gray-400 text-xs">{p.platforms?.join(", ") || "—"}</td>
              <td className="px-4 py-3"><StatusPill status={p.status} id={`crm-row-status-${p.id}`} /></td>
              <td className="px-4 py-3 text-gray-400 whitespace-nowrap">{fmtDate(p.last_contact_date)}</td>
              <td className={"px-4 py-3 whitespace-nowrap " + (p.next_follow_up_date && p.next_follow_up_date <= today && !["Customer", "Dead"].includes(p.status) ? "text-amber-300 font-semibold" : "text-gray-400")}>{fmtDate(p.next_follow_up_date)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
